import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Control, FieldValues } from 'react-hook-form';
import { AdministrationAddSortingCenterUserRoleForm, SortingCenter } from 'types';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { AdministrationAddSortingCenterUserRoleContext } from './types';
import ListUserRoles from './ListUserRoles';

const useStyles = makeStyles(theme => ({
  fieldLineRole: {
    marginTop: 8,
    width: '100%',
    display: 'inline-block',
    justifyContent: 'center',
  },
  titleHeader1: {
    marginTop: 8,
    '& p': {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '20px',
    },
  },
  treeBox: {
    width: '96%',
    marginTop: '5px',
    marginLeft: '10px',
    marginBottom: '20px',
    paddingTop: '20px',
    borderLeft: '1px solid #CFD4DA',
  },
  treeBoxBottom: {
    marginTop: '8px',
    width: '45%',
    borderBottom: '1px solid #CFD4DA',
  },
  primary: {
    color: theme.palette.primary.main,
  },
}));

interface ListItemSortingCenterUserRoleProps {
  sortingCenterParent: SortingCenter;
  previousStepData?: AdministrationAddSortingCenterUserRoleForm;
  formContext?: AdministrationAddSortingCenterUserRoleContext;
  sortingCenterUserRoleInitial: string[];
  control: Control<FieldValues, object>;
}

const ListItemSortingCenterUserRole: React.FC<ListItemSortingCenterUserRoleProps> = ({
  sortingCenterParent,
  previousStepData,
  formContext,
  sortingCenterUserRoleInitial,
  control,
}) => {
  const classes = useStyles();

  const sortingCenterChild: SortingCenter[] = [];
  sortingCenterParent.childrenSortingCenter?.map(sortingCenter => {
    const currentSortingCenterId = transformObjectId(sortingCenter);
    previousStepData?.sortingCenters?.map((doInclude, sortingCenterSelected) => {
      if (Boolean(doInclude) && parseInt(currentSortingCenterId, 10) === sortingCenterSelected) {
        sortingCenterChild.push(sortingCenter);
      }
      return null;
    });
    formContext?.sortingCentersInitial?.map((doInclude, sortingCenterSelected) => {
      if (Boolean(doInclude) && parseInt(currentSortingCenterId, 10) === sortingCenterSelected) {
        sortingCenterChild.push(sortingCenter);
      }
      return null;
    });
    return null;
  });

  const totalSortingCenter = sortingCenterChild.length;
  const hasMultipleChild = sortingCenterChild && sortingCenterChild.length > 1;

  return (
    <>
      {sortingCenterChild.length >= 1 ? (
        <div className={classes.fieldLineRole}>
          <div className={classes.titleHeader1}>
            <Typography>
              {hasMultipleChild ? sortingCenterParent.name : sortingCenterChild[0].name} -&nbsp;
              <span className={classes.primary}>
                {hasMultipleChild ? sortingCenterParent.code : sortingCenterChild[0].code}
              </span>
            </Typography>
          </div>
          <Box className={classes.treeBox}>
            {sortingCenterChild &&
              sortingCenterChild.map((sortingCenter: SortingCenter, index) => (
                <ListUserRoles
                  key={`sortingCenter.${index}`}
                  sortingCenter={sortingCenter}
                  totalSortingCenter={totalSortingCenter}
                  sortingCenterUserRoleInitial={sortingCenterUserRoleInitial}
                  control={control}
                />
              ))}
            <div className={classes.treeBoxBottom} />
          </Box>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default ListItemSortingCenterUserRole;
